// Shared BMI helpers (Asian / Thai cut-offs, WHO Asia-Pacific).
export type BmiLevel = 'under' | 'normal' | 'over' | 'obese1' | 'obese2';

export interface BmiInfo {
  value: number;
  level: BmiLevel;
  label: string;
  /** Traffic-light tone for UI. */
  tone: 'ok' | 'warn' | 'bad';
}

export function calcBmi(weightKg?: number | string | null, heightCm?: number | string | null): BmiInfo | null {
  const w = Number(weightKg);
  const h = Number(heightCm);
  if (!Number.isFinite(w) || !Number.isFinite(h) || w <= 0 || h <= 0) return null;
  const value = Math.round((w / Math.pow(h / 100, 2)) * 10) / 10;
  return { value, ...bmiLevel(value) };
}

export function bmiLevel(v: number): Omit<BmiInfo, 'value'> {
  if (v < 18.5) return { level: 'under', label: 'น้ำหนักน้อย', tone: 'warn' };
  if (v < 23) return { level: 'normal', label: 'สมส่วน', tone: 'ok' };
  if (v < 25) return { level: 'over', label: 'ท้วม', tone: 'warn' };
  if (v < 30) return { level: 'obese1', label: 'อ้วนระดับ 1', tone: 'bad' };
  return { level: 'obese2', label: 'อ้วนระดับ 2', tone: 'bad' };
}

/** Position (0-100%) of a BMI value on a 15–35 scale for the mini gauge. */
export function bmiGaugePct(v: number): number {
  return Math.min(100, Math.max(0, ((v - 15) / 20) * 100));
}

export function formatThaiDate(iso?: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('th-TH', { day: 'numeric', month: 'short', year: 'numeric' });
}
